<script setup>
import XerZenomoLayout from '@/components/XerZenomoLayout';
import betalingApi from '@/api/betaling.api.js';
import { useRouteExtensions } from '@/use/use-route-extensions';

const { aanbodNaam, aanvraagId } = useRouteExtensions();

function betaalViaSimulatie(simulatieScenario) {
  betalingApi.createBetaling(aanbodNaam.value, aanvraagId.value, simulatieScenario).then((data) => {
    window.location = data.redirectUrl;
  });
}
</script>
<template>
  <xer-zenomo-layout>
    <div class="xer-flex xer-flex-col xer-p-5 xer-mt-5">
      <h1 class="xer-heading-xxl xer-pb-5">Betaling simulatie</h1>

      <button
        class="xer-btn xer-btn--cta xer-m-4"
        data-automation-id="betaling-simulatie-betalen"
        @click="betaalViaSimulatie('mockscenario-success')"
      >
        Betalen
      </button>
      <button
        class="xer-btn xer-btn--danger xer-m-4"
        data-automation-id="betaling-simulatie-weigeren"
        @click="betaalViaSimulatie('mockscenario-rejected')"
      >
        Weiger
      </button>
      <button
        class="xer-btn xer-btn--danger xer-m-4"
        data-automation-id="betaling-simulatie-weigeren"
        @click="betaalViaSimulatie('mockscenario-cancelled')"
      >
        Cancel
      </button>
      <button
        class="xer-btn xer-btn--danger xer-m-4"
        data-automation-id="betaling-simulatie-weigeren"
        @click="betaalViaSimulatie('mockscenario-failed')"
      >
        Betaling failed
      </button>
    </div>
  </xer-zenomo-layout>
</template>
